// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indented-content{margin-bottom:2rem;display:grid}@media (min-width:768px){.indented-content{grid-template-columns:repeat(12,minmax(0,1fr))}}@media (min-width:768px){.indented-content__row{grid-column:span 11/span 11;grid-column-start:2}}@media (min-width:768px){.indented-content--narrow .indented-content__row{grid-column:span 10/span 10;grid-column-start:3}}.indented-content--nomargin{margin-bottom:0}@media (min-width:768px){.indented-content--nomargin{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
